import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f596d0f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner-instructions-heading" }

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  variant: {
    type: String,
  }
},
  setup(__props) {

const props = __props



const elClass = computed(() => {
  return [props.variant]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["banner-instructions", _unref(elClass)])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "heading")
    ])
  ], 2))
}
}

})